// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as $$Array from "../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as React from "react";
import * as CardSeparator from "../../../../order-dashboard/view/components/non-live-order-dashboard/components/CardSeparator.bs.js";
import * as RecordsWrapper from "../../../../order-dashboard/view/components/non-live-order-dashboard/components/RecordsWrapper.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";

function TicketCaseComments$CaseComment(Props) {
  var comment = Props.comment;
  return React.createElement("div", {
              className: "card-v3 info-card"
            }, React.createElement("div", {
                  className: "header"
                }, React.createElement("p", {
                      className: "title"
                    }, comment.author, React.createElement("span", undefined, Timestamp$Catalyst.toString(comment.created_at, "DD/MM/YY h:mm a")))), React.createElement(RecordsWrapper.make, {
                  children: React.createElement("div", {
                        className: "record"
                      }, comment.body)
                }));
}

var CaseComment = {
  make: TicketCaseComments$CaseComment
};

function TicketCaseComments(Props) {
  var comments = Props.comments;
  return React.createElement("div", {
              className: "primary-card primary-info-card"
            }, React.createElement("div", {
                  className: "header"
                }, React.createElement("p", {
                      className: "title"
                    }, "Case Comments")), $$Array.of_list(List.mapi((function (index, comment) {
                        return React.createElement(React.Fragment, undefined, React.createElement(TicketCaseComments$CaseComment, {
                                        comment: comment
                                      }), (List.length(comments) - 1 | 0) !== index ? React.createElement(CardSeparator.make, {}) : null);
                      }), comments)));
}

var make = TicketCaseComments;

export {
  CaseComment ,
  make ,
  
}
/* react Not a pure module */
